import React, { createContext, useContext, useState } from 'react';
const SearchContext = createContext(undefined);
export const SearchProvider = ({ children, }) => {
    const [focusedInput, setFocusedInput] = useState(null);
    const [isInputVisible, setIsInputVisible] = useState(false);
    const handleDepartureClick = () => {
        setIsInputVisible(true);
        setFocusedInput('departure');
    };
    const handleDestinationClick = () => {
        setIsInputVisible(true);
        setFocusedInput('destination');
    };
    const handleClose = () => {
        setIsInputVisible(false);
        setFocusedInput(null);
    };
    return (React.createElement(SearchContext.Provider, { value: {
            handleDestinationClick,
            handleClose,
            handleDepartureClick,
            focusedInput,
            isInputVisible,
        } }, children));
};
export const useSearch = () => {
    const context = useContext(SearchContext);
    if (context === undefined) {
        throw new Error('useSearch must be used within a SearchProvider');
    }
    return context;
};
//# sourceMappingURL=index.js.map